import React, { createContext, useContext, useEffect, useState } from "react";
import { io, Socket } from "socket.io-client";
import { useSelector } from "react-redux";
import { PUBLIC_URL } from "../../utils/constants";
import { enqueueSnackbar } from "notistack";

type SocketContextType = {
  socket: Socket | null;
};

const SocketContext = createContext<SocketContextType>({
  socket: null,
});

function SocketProvider({ children }: { children: React.ReactNode }) {
  const { token, profile } = useSelector((state: any) => state.auth);
  const [socket, setSocket] = useState<Socket | null>(null);

  useEffect(() => {
    if (profile?.email) {
      // init socket
      const socket = io(PUBLIC_URL);
      socket.on("connect", () => {
        socket.emit("login", { token, email: profile?.email });
        setSocket(socket);
      });
      socket.on("disconnect", () => {
        socket.emit("reconnect");
      });
      socket.on("login", (data) => {
        if (data.success) {
          console.log("Login success");
        }
      });
      socket.on("connect_error", () => {
        enqueueSnackbar({ variant: "error", message: "Lỗi kết nối máy chủ" });
      });
      socket.on("connect_timeout", () => {
        enqueueSnackbar({
          variant: "error",
          message: "Server không phản hồi, vui lòng thử lại",
        });
      });
    }
    return () => {
      socket?.disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profile?.email]);

  return (
    <SocketContext.Provider value={{ socket: socket }}>
      {children}
    </SocketContext.Provider>
  );
}

export default SocketProvider;

export const useSocketContext = () => {
  const value = useContext(SocketContext);
  if (!value) {
    throw new Error("SocketContext must be used side SocketProvider");
  }
  return value;
};
